module.exports = "/images/img_guide02_sp.png?e9ae2aff9df6795fd224bf9c5565b506";